import { errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const authWS = (state = { user: {}, register: false, forgot: false }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.AUTH.REGISTER:
      return Object.assign({}, state, { user: action.user, register: true, forgot: false })
    case Constants.ActionsConstants.AUTH.LOGIN:
      return Object.assign({}, state, { user: action.user, register: false, forgot: false })
    case Constants.ActionsConstants.AUTH.FORGOT:
      return Object.assign({}, state, { user: action.user, register: false, forgot: false })
    case Constants.ActionsConstants.AUTH.LOGOUT:
      // localStorage.removeItem('appStore')
      return Object.assign({}, state, { user: {}, register: false, forgot: false })
    default:
      return state
  }
}

export const setNewAccount = (data) => {
  return {
    type: Constants.ActionsConstants.AUTH.REGISTER,
    user: data,
  }
}

export function fetchNewAccountAction (dispatch, datas) {
  function fetchNewAccount () {
    let method = 'register'
    // dispatch(loading(method))

    let form = new FormData()
    form.append('json', JSON.stringify(datas))

    fetch(urlServer + method, {
      method: 'POST',
      body: form,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.authSuccess'))
        dispatch(setNewAccount(data))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  return {
    fetchNewAccount,
  }
}

export const setAccount = (data) => {
  return {
    type: Constants.ActionsConstants.AUTH.LOGIN,
    user: data,
  }
}

export function fetchAccountAction (dispatch, datas) {
  function fetchAccount () {
    let method = Constants.MethodsWSConstants.AUTH
    // dispatch(loading(method))

    let url = urlServer + method
    let authInfo = { email: datas.userName, password: datas.password }

    datas.password = null

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(authInfo),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        // dispatch(loaded(method))
        dispatch(loaded('Error.Croutons.authSuccess'))
        let authtoken = data.tokenInfo.accessToken
        let refreshtoken = data.tokenInfo.refreshToken
        Constants.UrlsConstants.header.authtoken = authtoken
        Constants.UrlsConstants.header.refreshtoken = refreshtoken
        Constants.UrlsConstants.authTokenParam =
          '?authtoken=' + authtoken
        datas.authtoken = authtoken
        datas.refreshtoken = refreshtoken

        // Get the user info
        datas.authorizations = data.authorizations
        datas.userRights = data.userRights
        datas.appRights = data.authorizations
        datas.isFreemium = data.isFreemium
        datas.nbAppMax = data.nbAppMax
        datas.email = data.email
        datas.firstname = data.firstname
        datas.lastname = data.lastname
        datas.teams = data.teams
        datas.countlyAPIKey = data.countlyApiKey
        dispatch(setAccount(datas))

        // this.props.history.push(Constants.RoutesConstants.root)
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.authFail'))
        }
      })
  }

  function deleteAccount () {
    let method = Constants.MethodsWSConstants.DELETE_ACCOUNT
    let url = urlServer + method
    fetch(url, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function modifyAccount () {
    let method = Constants.MethodsWSConstants.USER_MODIFICATION
    let url = urlServer + method
    let infoToUpdate = {
      email: datas.userName, firstname: datas.firstname,
      lastname: datas.lastname,
    }

    fetch(url, {
      method: 'PUT',
      body: JSON.stringify(infoToUpdate),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(setAccount(datas))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function modifyPassword () {
    let method = Constants.MethodsWSConstants.USER_MODIFICATION_PASSWORD
    // dispatch(loading(method))

    let url = Constants.UrlsConstants.urlServer + method

    let datasToSend = {
      newPassword: datas.password,
      oldPassword: datas.oldpassword,
    }

    delete datas.cpassword
    delete datas.password
    delete datas.oldpassword

    fetch(url, {
      method: 'PUT',
      body: JSON.stringify(datasToSend),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      // .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function setAccountInStore () {
    dispatch(setAccount(datas))
  }

  return {
    fetchAccount,
    deleteAccount,
    modifyAccount,
    modifyPassword,
    setAccountInStore,
  }
}

export const setForgottenAccount = (data) => {
  return {
    type: Constants.ActionsConstants.AUTH.LOGIN,
    user: data,
  }
}

export function fetchForgottenAccountAction (dispatch, datas) {
  function fetchForgottenAccount () {
    // dispatch(loading(method))

    // let authInfo = {email: datas.email}

    let method = Constants.UrlsConstants.userFOEntryPoint + Constants.MethodsWSConstants.REINIT_PASSWORD +
      '?email=' + encodeURIComponent(datas.email)
    // dispatch(loading(method))

    let url = urlServer + method

    fetch(url, {
      method: 'GET',
      // body: JSON.stringify(authInfo),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      // .then(r => r.json())
      .then(data => {
        // dispatch(loaded(method))
        dispatch(loaded('Error.Croutons.reinitPassword'))
        // dispatch(setForgottenAccount({}))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  return {
    fetchForgottenAccount,
  }
}

export const setLogout = () => {
  return {
    type: Constants.ActionsConstants.AUTH.LOGIN,
    user: {},
  }
}

export function fetchLogoutAction (dispatch) {
  function fetchLogout () {
    let method = Constants.MethodsWSConstants.LOGOUT
    let url = urlServer + method

    fetch(url, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(setLogout())
        window.location.href = '/'
      })
      .catch(error => {
        console.log(error)
        dispatch(setLogout())
      })
  }

  return {
    fetchLogout,
  }
}
